import { feedback } from '@/services/constants'

const ICONS = {
  // Star Ratings
  STAR: 'Star',
  STAR_FILLED: 'StarFilled',
  // Emoji Ratings
  SENTIMENT_VERY_DISSATISFIED: 'SentimentVeryDissatisfied',
  SENTIMENT_DISSATISFIED: 'SentimentDissatisfied',
  SENTIMENT_NEUTRAL: 'SentimentNeutral',
  SENTIMENT_SATISFIED: 'SentimentSatisfied',
  SENTIMENT_VERY_SATISFIED: 'SentimentVerySatisfied',
  // Thumbs Rating
  THUMB_UP: 'ThumbUp',
  THUMB_DOWN: 'ThumbDown',
  THUMB_UP_FILLLED: 'ThumbUpFilled',
  THUMB_DOWN_FILLED: 'ThumbDownFilled',
}

const COLORS = {
  // STAR
  STAR: '#6D6D6D',
  STAR_FILLED: '#ED9B1E',
  // EMOJI
  EMOJI: '#6D6D6D',
  EMOJI_FILLED: {
    [ICONS.SENTIMENT_VERY_DISSATISFIED]: '#E22C2C',
    [ICONS.SENTIMENT_DISSATISFIED]: '#F06C00',
    [ICONS.SENTIMENT_NEUTRAL]: '#B98C00',
    [ICONS.SENTIMENT_SATISFIED]: '#5AA700',
    [ICONS.SENTIMENT_VERY_SATISFIED]: '#008A00'
  },
  // Thumbs Rating
  THUMB: ''
}

const CONSTANTS = {
  FILLED: 'Filled'
}

const ENV = {
  LIVE: 'LIVE',
  SANDBOX: 'SANDBOX'
}

const RATING = {
  STAR: {
    value: 'STAR',
    component: 'StarRating'
  },
  EMOJI: {
    value: 'EMOJI',
    component: 'EmojiRating'
  },
  NUM_5: {
    value: 'NUM_5',
    component: 'NumberRating'
  },
  NUM_10: {
    value: 'NUM_10',
    component: 'NumberRating'
  },
  THUMBS_UP_DOWN: {
    value: 'THUMBS_UP_DOWN',
    component: 'ThumbsRating'
  }
}

const DEFAULT_RATING = [
  { id: '1', val: ICONS.SENTIMENT_VERY_DISSATISFIED, color: COLORS.EMOJI, label: 'very dissatisfied' },
  { id: '2', val: ICONS.SENTIMENT_DISSATISFIED, color: COLORS.EMOJI, label: 'dissatisfied' },
  { id: '3', val: ICONS.SENTIMENT_NEUTRAL, color: COLORS.EMOJI, label: 'neutral' },
  { id: '4', val: ICONS.SENTIMENT_SATISFIED, color: COLORS.EMOJI, label: 'satisfied' },
  { id: '5', val: ICONS.SENTIMENT_VERY_SATISFIED, color: COLORS.EMOJI, label: 'very satisfied' }
]

const RATINGS_LABEL = {
  EMOJI: {
    1: 'very dissatisfied',
    2: 'dissatisfied',
    3: 'neutral',
    4: 'satisfied',
    5: 'very satisfied'
  },
  THUMBS_UP_DOWN: {
    1: feedback.THUMBS_DOWN,
    2: feedback.THUMBS_UP
  },
}

export {
  ICONS, COLORS, CONSTANTS, ENV, RATING, DEFAULT_RATING, RATINGS_LABEL
}